import { combineReducers, configureStore } from "@reduxjs/toolkit";
import type { PreloadedState } from "@reduxjs/toolkit";
import { folderNameApi } from "./services/folderName";
import { locationApi } from "./services/location";
import campaignSlice from "./slice/campaignSlice";
import campaignSetupReducer from "./slice/campaignSetUpSlice";
import { campaignSetupApi } from "./services/campaignSetupService";
import userReducer from "./slice/userSlice";
import { userApi } from "./services/userService";
import { locationServiceApi } from "./services/locationService";
import whatsAppCampaignReducer from "./slice/whatsAppCampaignSlice";
import { whatsAppCampaignApi } from "./services/whatsAppCampaignService";
import campaignComposeReducer from "./slice/campaignComposeSlice";
import previewSlice from "./slice/previewSlice";
import { campaignListingApi } from "./services/campaignListingService";
import { campaignComposeApi } from "./services/campaignComposeService";
import loginSlice from "./slice/login.slice";

export const rootReducer = combineReducers({
  [folderNameApi.reducerPath]: folderNameApi.reducer,
  [locationApi.reducerPath]: locationApi.reducer,
  [locationServiceApi.reducerPath]: locationServiceApi.reducer,
  [campaignSetupApi.reducerPath]: campaignSetupApi.reducer,
  [whatsAppCampaignApi.reducerPath]: whatsAppCampaignApi.reducer,
  [campaignListingApi.reducerPath]: campaignListingApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [campaignComposeApi.reducerPath]: campaignComposeApi.reducer,
  campaign: campaignSlice,
  jobPreview: previewSlice,
  campaignSetup: campaignSetupReducer,
  user: userReducer,
  whatsAppCampaign: whatsAppCampaignReducer,
  campaignCompose: campaignComposeReducer,
  [loginSlice.name]:loginSlice.reducer
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(folderNameApi.middleware)
        .concat(campaignSetupApi.middleware),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
